import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const postDeleteApi = createAsyncThunk(
    'auth/posts/Delete',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.publicapiAction(`post`, 1), { data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const postDeleteSlice = createSlice({
    name: 'post Delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(postDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(postDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(postDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const postDeleteReducer = postDeleteSlice.reducer